module.exports = __webpack_public_path__ + "static/img/404.7d2d8c1b.svg";